export const Role = {
    Admin: 'ADMIN',
    AltaUsuario: 'ALTAUSUARIO',
    Integrador: 'INTEGRADOR',
    Operador: 'OPERADOR',
    Soporte: 'SOPORTE',
    Super: 'SUPERADMIN',
    Supervisor: 'SUPERVISOR',
}